var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, Checkbox, FormGroup, Modal, } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import Dropdown from 'components/v2/dropdowns/DropdownV2';
class CloneShipmentModal extends Component {
    constructor(props) {
        super(props);
        this.handleClone = () => {
            const _a = this.state, { numberOptions } = _a, remainOptions = __rest(_a, ["numberOptions"]);
            this.props.onClone(Object.assign({}, remainOptions));
        };
        this.handleClose = () => {
            this.setState({
                accessorials: false,
                documents: false,
                reference_numbers: false,
                tags: false,
                shipment_count: 1,
            });
            this.props.onHide();
        };
        this.handleFieldChange = (field) => {
            return () => {
                this.setState((prevState) => {
                    const updatedChecked = !prevState[field];
                    return { [field]: updatedChecked };
                });
            };
        };
        this.state = {
            accessorials: false,
            documents: false,
            reference_numbers: false,
            tags: false,
            numberOptions: Array.from({ length: 10 }, (_, v) => v + 1),
            shipment_count: 1,
        };
    }
    render() {
        const { show, t } = this.props;
        const { accessorials, documents, reference_numbers, tags, shipment_count, numberOptions, } = this.state;
        return (React.createElement(Modal, { show: show, onHide: this.handleClose, enforceFocus: false },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, t('CLONE_SHIPMENT'))),
            React.createElement(Modal.Body, null,
                React.createElement(FormGroup, null,
                    React.createElement(Checkbox, { onChange: this.handleFieldChange('accessorials'), checked: accessorials }, t('CLONE_ACCESSORIALS'))),
                React.createElement(FormGroup, null,
                    React.createElement(Checkbox, { onChange: this.handleFieldChange('documents'), checked: documents }, t('CLONE_DOCUMENTS'))),
                React.createElement(FormGroup, null,
                    React.createElement(Checkbox, { onChange: this.handleFieldChange('reference_numbers'), checked: reference_numbers }, t('CLONE_REFERENCE_NUMBERS'))),
                React.createElement(FormGroup, null,
                    React.createElement(Checkbox, { onChange: this.handleFieldChange('tags'), checked: tags }, t('CLONE_TAGS'))),
                React.createElement(FormGroup, { className: "ml-1 flex items-center space-x-2" },
                    React.createElement("p", null, t('CLONE_MULTIPLE_SHIPMENTS')),
                    React.createElement(Dropdown, { label: shipment_count }, numberOptions.map((num) => (React.createElement(Dropdown.Button, { onClick: () => this.setState({ shipment_count: num }) }, num)))))),
            React.createElement(Modal.Footer, null,
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { className: "shipment-cloneShipmentModal-cloneShipment heap", bsStyle: "primary", onClick: this.handleClone }, titleize(t('CLONE'))),
                    React.createElement(Button, { onClick: this.handleClose }, t('CANCEL'))))));
    }
}
CloneShipmentModal.propTypes = {
    show: PropTypes.bool,
    onClone: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
};
CloneShipmentModal.defaultProps = {
    show: false,
};
export default withTranslation()(CloneShipmentModal);
